<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="video_box">
       <h1 style="text-align:center;">How to cast</h1>
      <video playsinline style="width:100%" onloadedmetadata="this.muted=true" autoplay controls loop muted  >
        <source  src="/assets/images/learn_video.mp4" type="video/mp4"  />
     </video>
    </div>
    </div>
  </div>
</div>